import { render, staticRenderFns } from "./LsRadios.vue?vue&type=template&id=3c2e87ee&"
import script from "./LsRadios.vue?vue&type=script&lang=js&"
export * from "./LsRadios.vue?vue&type=script&lang=js&"
import style0 from "./LsRadios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports